import { Card, message, Modal, Input, Carousel, Button, notification, Tag, Image, Tooltip, List , Avatar, Pagination, Spin, Badge  } from 'antd';
import React, { useState, useEffect, useRef, Tabs, Fragment } from 'react';
import { useDispatch, useSelector } from "react-redux";
import sanitizeHtml from 'sanitize-html';
import buble_ca from '../img/buble_ca.png';
import ansan_cha1 from '../img/ansan_cha1.png';
import book_see_chat_1 from '../img/JungRakCharacter/07.png';
import book_see_chat_2 from '../img/JungRakCharacter/02.png';
import book_see_chat_3 from '../img/JungRakCharacter/03.png';
import book_see_chat_7 from '../img/JungRakCharacter/07.png';
import book_see_chat_13 from '../img/JungRakCharacter/13.png';
import book_see_chat_10 from '../img/JungRakCharacter/10.png';
import book_see_chat_11 from '../img/JungRakCharacter/11.png';
import book_see_chat_24 from '../img/JungRakCharacter/24.png';

// 모르겠거나 검색단어 물어볼 때
import book_see_chat_12 from '../img/JungRakCharacter/12.png';
import book_see_chat_8 from '../img/JungRakCharacter/13.png';

import axios from 'axios';

import { FacebookOutlined, CheckOutlined, TwitterOutlined, YoutubeOutlined, ArrowRightOutlined, MehTwoTone,FrownTwoTone, SmileTwoTone, LoadingOutlined, CommentOutlined  } from '@ant-design/icons';
import { saveApplyList, saveText } from '../../../_actions/chatbot_actions';
import { deleteApplyCancelList, deleteApplyList } from '../../../_actions/list_actions';

import QueueAnim from 'rc-queue-anim';
//img 경로 재처리

const { TextArea } = Input;

function BotMessage(props) {
	
	const [Text, setText] = useState('')
	const [ModalOpen, setModalOpen] = useState(false)
	const [confirmLoading, setConfirmLoading] = useState(false);
  	const [modalText, setModalText] = useState('');
	const slider = useRef(null);
	const [ButtonDisable, setButtonDisable] = useState(false);
	const [HopeBookData, setHopeBookData] = useState([]);
	const dispatch = useDispatch();
	const [ModalTitle, setModalTitle] = useState('');
	const [Current, setCurrent] = useState(1);
	const [PageSize, setPageSize] = useState(5);
	const tossToParentHandler = (val, libName, manageCode) => {
		props.handleFilters(val, libName, manageCode);
	};

	const closeModal = () => {
		setModalOpen(false);
		setConfirmLoading(false);
	  };

	const params 			= props.params;
	const type 				= params.type;
	const ApplyList 		= params.ApplyList;
	const finishValuation 	= params.finishValuation;
	const intentEng 		= params.intentEng;
	const libName 			= params.libName;
	const Answer 			= params.Answer;
	const SearchKeyword 	= params.SearchKeyword;
	const Title 			= params.Title;
	const WebLink 			= params.WebLink;
	const DfMsg 			= params.DfMsg;
	const WelcomeStart 		= params.WelcomeStart;
	const SubIntents 		= params.SubIntents;
	const SubIntents2 		= params.SubIntents2;
	const ChoiceLibrary 	= params.ChoiceLibrary;
	const hopeApplyCancelList = params.hopeApplyCancelList;
	const libCode 			= params.libCode
	const bookReservationList = params.bookReservationList
	const bookReservationListForCancel = params.bookReservationListForCancel;
	const messagesFromRedux = useSelector(state => state)

	const dataList = messagesFromRedux.list.dataList;
	const totalCount = messagesFromRedux.list.totalCount;
	const dataCancelList = messagesFromRedux.list.dataCancelList;
	let reasonText = '';

	if(finishValuation) {
		// console.log('params' , params);
		// console.log('finishValuation' , finishValuation);
	}
    const [isPaused, setIsPaused] = useState(null);
    const [voice, setVoice] = useState(null);
    const [rate, setRate] = useState(1);
    const [volume, setVolume] = useState(1);
	
	if (WelcomeStart === 'Y') {
	}

	const info = () => {

		message.info({
			content: '서비스 준비중',
			className: 'custom-class',
			style: {
				marginTop: '20vh'
			}
		});
	};
	
	const unsecuredCopyToClipboard = (text) => { 
		const textArea = document.createElement("textarea");
		 textArea.value=text;
		 document.body.appendChild(textArea); 
		 textArea.focus();
		 textArea.select();
		  try
		  {
			document.execCommand('copy')
		  }catch(err){
			console.error('Unable to copy to clipboard',err)
         }
		 document.body.removeChild(textArea)
	};

	const openNotification = async(Title, cleanCode) => {
		
		notification.open({
			cursor: 'pointer',
			placement: 'topLeft',
			message: Title,
			description: cleanCode,
			onClick: async() => {
			try {
				if (window.isSecureContext && navigator.clipboard) {
				await navigator.clipboard.writeText(cleanCode);
				} else {
					unsecuredCopyToClipboard(cleanCode);
				}
				message.info("복사 완료");
			} catch (err) {
				message.error('복사 실패')
				console.log(err);
			}
				// info();
			}
		});
	};


	const inputRequestReason = (event) => {
		
		reasonText = event.currentTarget.value
		
	  }

	  const onShowSizeChange = async(current, pageSize) => {
		setCurrent(current);
		setPageSize(pageSize);
		
		const headers = {
			'x-access-token': sessionStorage.getItem('userToken'),
			'Content-Type': 'application/json'
		};
		const config = {
			headers
		};

		const formData = {
			serviceName : 'hopeBookSearch',
			bodyParam: {
				SearchKeyword,display:pageSize,page:current
			}
		};

		const response = await axios.post('/v1/bot/kolasService', formData, config);


		if(response.data.code === 'Y') {
			await dispatch(saveApplyList( {totalCount : response.data.totalCount, applyList : response.data.bookList}))
		}

	  };

	  const showApplyList = async() => {
		if(!dataList) return message.info('책이 없어요');

		dataList.filter((elem , index) => {

		})
		if(dataList.length>10) {

		}

	    setModalTitle('희망도서 신청 목록');
		setModalOpen(true);
		setModalText(	
			<div>
			<List
			itemLayout="horizontal"
			dataSource={dataList}
			renderItem={(item) => (
			  <List.Item>
				<List.Item.Meta
				  avatar={<Avatar src={item.thumbnail} />}
				  title={item.title}
				  description= {<div>도서 가격 : {item.price}원</div>} 
				/>
				<Button onClick={()=>{checkNotification(item)}}>신청</Button>
			  </List.Item>	
	
				)}
				/>
				</div>
				)
	
	  }
	
	  const showHopeBookApplyCancelList = () => {
		if(!dataCancelList) return message.info('취소할 책이 없어요');

		setModalOpen(true);
		setModalTitle('희망도서 신청 취소 목록')
		setModalText(	
		<List
			itemLayout="horizontal"
			dataSource={dataCancelList}
			renderItem={(item) => (
			  <List.Item>
				<List.Item.Meta
				  avatar={<Avatar src={item.coverUrl} />}
				  title={item.title}
				  description= {<div>신청날짜 : {item.applicantDate}</div>} 
				/>
			<Button  onClick={()=>{hopeBookApplyCancel(item.applicantKey, item.libCode)}}>신청취소</Button>
			  </List.Item>
	
				)}
				/>)
	
	  }

	
	const checkNotification = async(book) => {
		setText('');

		const key = `open${Date.now()}`;

		const btn = (
			<div style={{width: 'max-content'}}>
			<div>신청사유</div>
			<TextArea style={{width: '280px'}} rows={4} onChange={inputRequestReason}/>
			<div style={{textAlign:'center'}}><br/>
			<Button
				type="primary"
				size="small"
				onClick={() => {
					hopeBookApply(book.isbn, book.contentsId, libCode, reasonText);
					notification.close(key);
				}}
			>
				신청하기
			</Button>
			</div>
			</div>
		);

		const close = () => {};

		notification.open({
			cursor: 'pointer',
			placement: 'topLeft',
			message: '희망도서신청  확인',
			description: (
				<div>
					<br /> 제목: {book.title}
					<br />도서 가격: {book.price}원
					<br />저작자: {book.author}
				</div>
			),
			btn,
			key,
			onClose: close
		});
	};

	const timer = () => {
		let today = new Date();
		let hour = today.getHours();
		let minute = today.getMinutes();
		let ampm = '';
		let timeResult = '';
		ampm = hour >= 12 ? '오후' : '오전';
		hour = hour >= 12 ? hour - 12 : hour;
		hour = hour === 0 ? 12 : hour;
		minute = minute >= 0 && minute <= 9 ? '0' + minute : minute;
		timeResult = `${ampm} ${hour}:${minute}`;

		return timeResult;
	};

	let cleanCode = '';
	console.log('Answer', Answer);
	if (DfMsg) {
		const text = DfMsg.replace(/(<([^>]+)>)/ig, "");

		cleanCode = sanitizeHtml(DfMsg);
	} else {
		if(!Answer)  {
			cleanCode = sanitizeHtml( '해당 도서관의 데이터가 없습니다.');
		} else {
			const text = Answer.replace(/(<([^>]+)>)/ig, "");

		// const imgTags = Answer.match(/<img\b[^>]*>/gi) || [];
		// cleanCode = sanitizeHtml(Answer);

		// // img 태그들을 문자열로 다시 결합
		// cleanCode = cleanCode + imgTags.join("");

		// // updatedCleanCode에는 깨끗한 HTML과 img 태그가 포함됨
		// console.log(cleanCode);


		const imgTags = Answer.match(/<img\b[^>]*>/gi) || [];
		const resizedImgTags = imgTags.map(tag => tag.replace(/<img/, '<img style="max-width:100%; height:auto;"'));
		cleanCode = sanitizeHtml(Answer);

		// img 태그를 다시 결합
		cleanCode =  '<br/>' + resizedImgTags.join("") + cleanCode;

		}
	}

	const hopeBookApply = async (isbn, contentsId, libCode, requestReason) => {

		if(!requestReason) {
			return message.info('신청사유를 입력해주세요.')
		}
		const headers = {
			'x-access-token': sessionStorage.getItem('userToken'),
			'Content-Type': 'application/json'
		};
		const config = {
			headers
		};
		const formData = {
			serviceName : 'hopeBookApply',
			bodyParam: {
				isbn,
				contentsId,
				requestReason,
				libCode
			}
		};

		const response = await axios.post('/v1/bot/kolasService', formData, config);

		if(response.data.code === 'Y') {
			await dispatch(deleteApplyList({dataList:messagesFromRedux.list.dataList,isbn,totalCount}))
			setModalOpen(false);
		}
		return message.info(response.data.message);

	};

	const bookReservationCancel = async(reserveKey) => {

		const headers = {
			'x-access-token': sessionStorage.getItem('userToken'),
			'Content-Type': 'application/json'
		};
		const config = {
			headers
		};
		const formData = {
			serviceName : 'bookReservationCancel',
			bodyParam: {
				reserveKey
			}
		};

		const response = await axios.post('/v1/bot/kolasService', formData, config);

		return message.info(response.data.message);
	}

	const hopeBookApplyCancel = async(applicantKey, libCode) => {

		const headers = {
			'x-access-token': sessionStorage.getItem('userToken'),
			'Content-Type': 'application/json'
		};
		const config = {
			headers
		};
		const formData = {
			serviceName : 'hopeBookApplyCancel',
			bodyParam: {
				applicantKey,
				libCode
			}
		};

		const response = await axios.post('/v1/bot/kolasService', formData, config);

		if(response.data.code === 'Y') {

			await dispatch(deleteApplyCancelList({dataCancelList:messagesFromRedux.list.dataCancelList, applicantKey}))
			setModalOpen(false);
			
		}

		return message.info(response.data.message);
	}

	const openLink = () => {
		window.open(WebLink, '_blank');
	};

	
	const chatbotFeedBack = async(code) => {
	
		try {
			const formData = {
				valuation:code,
				intent:intentEng,
				libName:libName,
			};

			const response = await axios.post('/v1/bot/chatbotFB', formData);

			if(response.data.data.success) {
				setButtonDisable(true);
				return message.info('소중한 의견 감사합니다.');
			} else {
				return message.info('의견에 반영되지 못했습니다.');
			}
			} catch (e) {
				message.error('의견에 반영되지 못했습니다.')
			}

	}

	  const choiceImg = () => {

		const num =  Math.random()*10

		if(WelcomeStart==='Y') {

			return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>안녕하세요!</span>}>
			<img src={book_see_chat_1} />
			</Tooltip>
							
								// 	return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>안녕하세요!</span>}>
								// 	<img src={book_see_chat_2} />
								// </Tooltip>
								// 	return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>안녕하세요!</span>}>
								// 	<img src={book_see_chat_7} />
								// </Tooltip>
								// 	return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>안녕하세요!</span>}>
								// 	<img src={book_see_chat_13} />
								// </Tooltip>
								// 	return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>안녕하세요!</span>}>
								// 	<img src={book_see_chat_3} />
								// </Tooltip> 
		}

		if(ApplyList) {

		}


		if(ChoiceLibrary) {
			return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>도서관 선택</span>}>
			<img src={book_see_chat_11} />
		  </Tooltip>
		}

		if(WebLink) {
			return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>링크와 정보안내1</span>}>
			<img src={book_see_chat_10} />
		  </Tooltip>
		}

		if(Answer) {
			return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>정보안내2</span>}>
			<img src={book_see_chat_3} />
		  </Tooltip>
		}

			return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>잘모르겠어요</span>}>
			<img src={book_see_chat_24} />
		</Tooltip>
		// 	return 	<Tooltip placement="bottom" color='#2db7f5' title={<span>잘모르겠어요</span>}>
		// 	<img src={book_see_chat_8} />
		// </Tooltip>
		
	  }

	return (
		<div>
		<Modal
        title= {ModalTitle}
		description="1"
        open={ModalOpen}
		footer={null}
		centered={true}
		closable={true}
		onCancel={closeModal}
		>
		{modalText}
		</Modal>

			<div className="chat--log bot">
				<i>
					{
					choiceImg()
					 }
					{/* <MessageTwoTone style={{fontSize :35}} onClick={()=> message.success('Chatbot이 말합니다.')} alt="챗봇"/> */}
				</i>

				<div
					className="chat"
					id="chatHomeMsg"
					style={{ cursor: 'pointer' }}
					onClick={() => openNotification(Title, sanitizeHtml(cleanCode))}
				>

					{Title ? <h3>{Title}</h3> : null}
					{/* {type ? 
						<div> 
						<Badge.Ribbon style={{ float: 'right' }}  text="챗 지피티 플러스" color="pink">     
					  		<Card title="'ChatGPT' 답변 - 정확한 답변은 도서관에 문의하세요."  size="small">
							  <div dangerouslySetInnerHTML={{ __html: cleanCode }} />
							</Card> 
	  					</Badge.Ribbon> 
						</div> : 
						<div>
						<div dangerouslySetInnerHTML={{ __html: cleanCode }} />
						<div id="libNamePosition" />
						</div>
						} */}
						<div>
						<div dangerouslySetInnerHTML={{ __html: cleanCode }} />
						<div id="libNamePosition" />
						</div>
	
				</div>

				<div className="chat-time" style={{ cursor: 'pointer' }} onClick={info}>
					<span>{timer()}</span>
				</div>
			</div>

			{bookReservationListForCancel && bookReservationListForCancel.length  >= 1 ? (
				<div className="chat-book">
					<div className="scroll">
						<ul>
							<i
								className="prev"
								onClick={() => {
									slider.current.prev();
								}}
							>
								〈{' '}
							</i>
							<Carousel autoplay ref={slider} dots={false}>
								{
								bookReservationListForCancel.map((resevedBookList, i) => {
								
									return (
										<div key={i}>
											<li>
												<img
													onClick={() => {
														message.info('서비스 준비중');
													}}
													src={resevedBookList.coverUrl}
													alt=""
												/>
												<div className="info">
													<p className="tlt">제목: {resevedBookList.title}</p>
													<p className="pub">신청 날짜: {resevedBookList.reservationDate}</p>
													<p className="pub">신청 도서관: {resevedBookList.libName}</p>
													<div className="state">
													<button className="btn-list"  onClick={()=>{bookReservationCancel(resevedBookList.reserveKey)}} >신청 취소</button>
													</div>
												</div>
											</li>
										</div>
									);
								})}
							</Carousel>
						</ul>
					</div>
					<i className="next" onClick={() => slider.current.next()}>
						{' '}
						〉
					</i>
					<button className="btn-list">목록보기</button>
				</div>
			) : null}



{bookReservationList && bookReservationList.length  >= 1 ? (
				<div className="chat-book">
					<div className="scroll">
						<ul>
							<i
								className="prev"
								onClick={() => {
									slider.current.prev();
								}}
							>
								〈{' '}
							</i>
							<Carousel autoplay effect="fade" ref={slider} dots={false}>
								{
								bookReservationList.map((resevedBookList, i) => {
								
									return (
										<div key={i}>
											<li>
												<img
													onClick={() => {
														message.info('서비스 준비중');
													}}
													src={resevedBookList.coverUrl}
													alt=""
												/>
												<div className="info">
													<p className="tlt">제목: {resevedBookList.title}</p>
													<p className="pub">신청 날짜: {resevedBookList.reservationDate}</p>
													<p className="pub">신청 도서관: {resevedBookList.libName}</p>
													<div className="state">
													<p className="red">자료 요청 상태: {resevedBookList.reserveStatus}</p>
													</div>
												</div>
											</li>
										</div>
									);
								})}
							</Carousel>
						</ul>
					</div>
					<i className="next" onClick={() => slider.current.next()}>
						{' '}
						〉
					</i>
		
				
				</div>
			) : null}



			{hopeApplyCancelList && dataCancelList && dataCancelList.length  >= 1 ? (
				<div className="chat-book">
					<div className="scroll">
						<ul>
							<i
								className="prev"
								onClick={() => {
									slider.current.prev();
								}}
							>
								〈{' '}
							</i>
							<Carousel autoplay effect="fade" ref={slider} dots={false}>
								{
								dataCancelList.map((hopeApplyCancelList, i) => {
								
									return (
										<div key={i}>
											<li>
												<img
													onClick={() => {
														message.info('서비스 준비중');
													}}
													src={hopeApplyCancelList.coverUrl}
													alt=""
												/>
												<div className="info">
										
													<p className="tlt">제목: {hopeApplyCancelList.title}</p>
													<p className="pub">신청 날짜: {hopeApplyCancelList.applicantDate}</p>
													<p className="pub">신청한 도서관: {hopeApplyCancelList.applicantPlace}</p>
													<div className="state">
													<button className="btn-list"  onClick={()=>{hopeBookApplyCancel(hopeApplyCancelList.applicantKey, hopeApplyCancelList.libCode)}} >신청 취소</button>
													</div>
												</div>
											</li>
										</div>
									);
								})}
							</Carousel>
						</ul>
					</div>
					<i className="next-2" onClick={() => slider.current.next()}>
						{' '}
						〉
					</i>
				
				
					<button className="btn-list"  onClick={showHopeBookApplyCancelList}>목록보기</button>
				
				</div>
			) : null}


			{ApplyList && dataList&& dataList.length >= 1 ? (
			<div>
				<div className="chat-book">
					<div className="scroll">
						<ul>
							<i
								className="prev"
								onClick={() => {
									slider.current.prev();
								}}
							>
								〈{' '}
							</i>
				
							<Carousel autoplay effect="fade" ref={slider} dots={false}>
								{
									
								dataList.map((ApplyList, i) => {
									return (
										<div key={i}>
											<li>
												<img
													onClick={() => {
														message.info('서비스 준비중');
													}}
													src={ApplyList.thumbnail}
													alt=""
												/>
												<div className="info">
										
													<p className="tlt">제목: {ApplyList.title}</p>
													<p className="pub">작가: {ApplyList.author}</p>
													<p className="pub">출판사: {ApplyList.publisher}</p>
													<p className="pub">발행연도: {ApplyList.pubYear}</p>
													<p className="price">가격: {ApplyList.price}원</p>
													<div className="state">
														<button className="btn2-list" onClick={()=>{checkNotification(ApplyList)}}>희망도서 신청</button>
													</div>
												</div>
											</li>
										</div>
									);
								})}
							</Carousel>
						</ul>
						

					</div>
					<i className="next" onClick={() => slider.current.next()}>
						{' '}
						〉
					</i>
			
					<button className="btn-list" onClick={showApplyList}>목록보기</button>
					
				</div>
				<div className='pagination-container'>
					<Pagination
						size='small'
						current={Current}
						showSizeChanger={true}
						onChange={onShowSizeChange}
						defaultCurrent={1}
						total={totalCount}
						/>
					</div>
				</div>
			) : null}

			{ChoiceLibrary ? (
				<ul className="reservebook-list">
					{ChoiceLibrary.map((element, i) => {

						if(!element) return;

						return (
							<li
								key={i}
								style={{ cursor: 'pointer' }}
								onClick={() => {
									tossToParentHandler(`${element.libName}`, element.libName);
								}}
							>
								<i>{element.libName}</i>
							</li>
						);
					})}
				</ul>
			) : null}

			{WebLink ? (
				<Button
					style={{ fontSize: '13px', background: '#6478aa', border: 'none' }}
					className="link-button"
					type="primary"
					onClick={openLink}
					block
				>
					더 알아보기({Title}) <ArrowRightOutlined />
				</Button>
			) : null}
	
			{WelcomeStart === 'Y' ? (
	
					
				<ul className="chat-help">
				
					<li onClick={() => tossToParentHandler('도서관 소개')}>
						<i>도서관 소개</i>
					</li>
					<li onClick={() => tossToParentHandler('도서 자료 현황')}>
						<i>도서 자료현황</i>
					</li>
					<li onClick={() => tossToParentHandler('시설현황')}>
						<i>시설현황</i>
					</li>
					<li onClick={() => tossToParentHandler('찾아오시는길')}>
						<i>
							찾아<br />오시는 길
						</i>
					</li>
					<li onClick={() => tossToParentHandler('자료실이용시간')}>
						<i>
							자료실<br />이용시간
						</i>
					</li>
					<li onClick={() => tossToParentHandler('휴관일안내')}>
						<i>
							휴관일<br />안내
						</i>
					</li>
					<li onClick={() => tossToParentHandler('대출 회원가입')}>
						<i>
						도서관 대출 회원가입
						</i>
					</li>
					<li onClick={() => tossToParentHandler('도서관 연락처')}>
						<i>
						도서관 연락처
						</i>
					</li>
					<li onClick={() => tossToParentHandler('공지사항')}>
						<i>공지사항</i>
					</li>
					<li onClick={() => tossToParentHandler('희망도서 신청 안내')}>
						<i>희망도서 신청 안내</i>
					</li><li onClick={() => tossToParentHandler('도서관 일정')}>
						<i>도서관 일정</i>
					</li>
					<li onClick={() => tossToParentHandler('추천도서')}>
						<i>추천도서</i>
					</li>
				</ul>
			) : (

				<ul className="help-list no-ico">
					
						  {SubIntents ? (
							  SubIntents.map((element, i) => {
								  return (
									  <li
										  key={i}
										  style={{ cursor: 'pointer' }}
										  onClick={() => {
											  tossToParentHandler(element.sign);
										  }}
									  >
										  {element.sign}
									  </li>
								  );
							  })
						  ) : null}
						  {SubIntents2 ? (
							  SubIntents2.map((element, i) => {
								  return (
									  <li
										  key={i}
										  style={{ cursor: 'pointer' }}
										  onClick={() => {
											  tossToParentHandler(element.sign);
										  }}
									  >
										  {element.sign}
									  </li>
								  );
							  })
						  ) : null}
					  </ul>
			
			

			)
			
			}

		{finishValuation ? (	
		<Badge.Ribbon text="답변 만족도 "><br/>
			<div  style={{display: 'flex', flexDirection:'row-reverse'}}>
				<div className='value-box' style={{display: 'flex', marginBottom: '25px', marginTop: '25px'}}>

				<Tooltip placement="top" color='#2db7f5' title={<span>좋아요!</span>}>
					<Button
						disabled={ButtonDisable}
						style={{ borderRadius:'40px', fontSize: '25px', background: 'white', height: '40px', marginRight: '10px', paddingTop:' 0px', border:'1px solid #52c41a'}}
						className="link-button"
						type="primary"
						onClick={()=> {chatbotFeedBack('good')}}
					>
					<SmileTwoTone  twoToneColor="#52c41a"/>
					</Button>
              </Tooltip>

			  <Tooltip placement="top" color='#2db7f5' title={<span>그저 그래요!</span>}>
					<Button
							disabled={ButtonDisable}
							style={{ borderRadius:'40px', fontSize: '25px', background: 'white', height: '40px',  marginRight: '10px', paddingTop: '0px', border:'1px solid blue'}}
							className="link-button"
							type="primary"
							onClick={()=> {chatbotFeedBack('normal')}}
						>
							<MehTwoTone />
					</Button>
              </Tooltip>

			  <Tooltip placement="top" color='#2db7f5' title={<span>아쉬워요!</span>}>
					<Button
							disabled={ButtonDisable}
							style={{ borderRadius:'40px', fontSize: '25px', background: 'white', height: '40px', paddingTop: '0px', border:'1px solid #eb2f96'}}
							className="link-button"
							type="primary"
							onClick={()=> {chatbotFeedBack('bad')}}
						>
							<FrownTwoTone  twoToneColor="#eb2f96" />
					</Button>
              </Tooltip>
				</div>
				 </div> 
				 </Badge.Ribbon>
				 )
				 : null
				}

			{WelcomeStart === 'Y' ? (

				<div className="sub-help-list">
   

				<QueueAnim delay={500} className="queue-simple">
					<Tag key="b"
						icon={<YoutubeOutlined />}
						style={{ cursor: 'pointer' }}
						onClick={() => window.open('https://www.youtube.com/playlist?app=desktop&list=PLqqe7dWj5W_AP2MigwoIJgap3FYmpKzOo', '_blank')}
						color="#cd201f"
					>
						Youtube
					</Tag>
					<Tag key="c"
						icon={<FacebookOutlined />}
						style={{ cursor: 'pointer' }}
						onClick={() => window.open('https://www.facebook.com/profile.php?id=1815447292115547&paipv=0&eav=AfYGuoIGc-_Y2BSqF96WWAZdQAh4mQXQ_eDHpX2pf_B1tjb2OsOfpmPhkOA_speRpa8&_rdr', '_blank')}
						color="#3b5999"
					>
						Facebook
					</Tag>
					</QueueAnim>
				</div>
			) : null}

			
		</div>
	);
}

export default BotMessage;
